// ── 운영자가 사이드바 작업대상으로 고른 고객 테넌트 회사 (2026-09-15) ─────────
//
// 사용자 신고: link 로 작업대상=유기자차를 골라도 화면이 그 테넌트를 따라가지 않았다.
//   서버가 선택을 몰라서, 미팅지도·계약은 전 테넌트, 상품은 운영사 것이 열렸다.
//
// CompanyScopeContext 가 쓰고, apiClient 가 **요청할 때마다** 읽어 X-Scope-Company 헤더로 싣는다.
//   메모리 변수가 아니라 localStorage 인 이유: 새로고침 직후 자식 화면의 첫 요청이 부모(선택창)의
//   effect 보다 먼저 나간다. 저장값을 바로 읽어야 첫 요청부터 좁혀진다.
//
// 서버는 **운영사 소속일 때만** 이 값을 믿는다(tenant-scope.service.js operatorSelectedCompany).
//   고객 테넌트 사용자가 보내도 무시되므로 좁히기만 할 뿐 권한을 넓히지 않는다.

export const SCOPE_COMPANY_KEY = 'companyScope.serverScope';

export function readScopeCompany() {
  try { return localStorage.getItem(SCOPE_COMPANY_KEY) || null; } catch (_) { return null; }
}

/** code 가 없으면 지운다. 같은 값이면 쓰지 않는다(렌더 중에 불려도 부담 없게). */
export function writeScopeCompany(code) {
  try {
    const next = code ? String(code).toUpperCase() : null;
    if ((localStorage.getItem(SCOPE_COMPANY_KEY) || null) === next) return;
    if (next) localStorage.setItem(SCOPE_COMPANY_KEY, next);
    else localStorage.removeItem(SCOPE_COMPANY_KEY);
  } catch (_) { /* 저장 불가 환경 — 헤더 없이 동작 */ }
}
